import * as actions from './gift-credits.actions'
import { CreditsSummary, CompanyContent } from 'src/services/ds.service'
import { identity } from 'fp-ts/lib/function'
import { Lens } from 'monocle-ts'
import { none, some, Option } from 'fp-ts/lib/Option'
import { Reducer } from 'src/framework'
import { UserIdentity } from 'src/users-components/login/login.reducer'

export interface GiftCreditsState {
  testId: Option<string>
  identity: Option<UserIdentity>
  company: Option<CompanyContent>
  credits: Option<CreditsSummary>
}

export const initialGiftCreditsState: GiftCreditsState = {
  testId: none,
  identity: none,
  company: none,
  credits: none
}

export const testIdLense = Lens.fromProp<GiftCreditsState>()('testId')
export const creditsLense = Lens.fromProp<GiftCreditsState>()('credits')
export const companyLense = Lens.fromProp<GiftCreditsState>()('company')

export const sameState: (s: GiftCreditsState) => GiftCreditsState = identity

export const giftCreditsReducer: Reducer<
  actions.GiftCreditsActions,
  GiftCreditsState
> = actions.giftCreditsActions.match({
  SelectTest: action => testIdLense.set(action.testId),
  SelectCompany: action => companyLense.set(action.company),
  LoadCreditsSuccess: action => creditsLense.set(some(action.credits)),
  default: _action => sameState
})



// WEBPACK FOOTER //
// ./src/credits-components/gift-credits/gift-credits.reducer.ts